const data = [{
    "category": {
        "id": 1,
        "name": "Anti Cancer Injection"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Naproplat 450mg / 45 ml Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366838113/HL/IG/KW/13363752/naproplat-450mg-45-ml-injection-1000x1000.jpg",
            "price": "₹ 1000 / Vial",
            "info": {
                "description": "Naproplat 450 mg/45 ml (Carboplatin Injection IP 450mg/45 ml)Company: Miracalus Pharma Pvt Ltd.We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "1 vial",
                "Brand": "Naproplat 450mg/45 ml",
                "Composition": "Carboplatin 450mg/45 ml",
                "Manufacturer": "Miracalus Pharma Pvt Ltd",
                "Treatment": "Ovarian Cancer & Small Cell Lung Cancer",
                "Prescription/Non prescription": "Prescription",
                "Dosage Form": "450 mg",
                "Dose Strength": "450 mg",
                "Category": "Lung Cancer",
                "Drug": "Carboplatin 450 mg"
            }
        },
        {
            "id": 1,
            "name": "50mg Tigebax Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2021/1/DG/WV/WZ/13363752/tig-1-500x500.jpg",
            "price": "₹ 337 / Vial",
            "info": {
                "description": "Company- Glenmark Pharmaceuticals LtdUses- treating bacterial infectionsComposition - Tigecycline 50 mg",
                "Brand": "Tigebax",
                "Manufacturer": "Gufic Biosciences Ltd",
                "Composition": "Tigecycline 50mg",
                "Treatment": "Bacterial Infection",
                "Prescription/Non prescription": "Prescription",
                "Form": "Injection",
                "Country of Origin": "Made in India"
            }
        },
        {
            "id": 2,
            "name": "Emgrast 300 Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2020/8/JS/BX/VX/13363752/e1-500x500.jpeg",
            "price": "₹ 400 / Piece",
            "info": {
                "description": "Emgrast 300 mcg Injection (Filgrastim Injection I.P. mcg/0.5 ml)(3 x 107 IU/0.5 ml)Company: Emcure Pharmaceuticals Ltd.",
                "Packaging Size": "PFS",
                "Composition": "Filgrastim INjection I.P. 300 mcg / 0.5 ml",
                "Manufacturer": "Emcure Pharmaceuticals Ltd",
                "Brand": "Emgrast 300 mcg",
                "Treatment": "To prevent infections after chemotherapy",
                "Packaging": "PFS",
                "Prescription/Non prescription": "Prescription",
                "Dosage Form": "300 mcg",
                "Storage": "2 to 8'c",
                "Form": "Injection"
            }
        },
        {
            "id": 3,
            "name": "TrastuRel 440 mg Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366839907/EO/UC/HV/13363752/trasturel-440-mg-injection-500x500.jpg",
            "price": "₹ 14000 / Vial",
            "info": {
                "description": "TrastuRel 440 mg (r-DNA origin) 440 mg Reliance Trastuzumab for injection.Company: Reliacnce Life Sciences Pvt Ltd.",
                "Packaging Size": "1 vial",
                "Brand": "TrastuRel 440 mg",
                "Composition": "Trastuzumab 440 mg",
                "Manufacturer": "Reliance Life Sciences Pvt Ltd",
                "Treatment": "Breast Cancer & Stomach Cancer",
                "Prescription/Non prescription": "Prescription",
                "Dose Strength": "440 mg",
                "Category": "Breast Cancer",
                "Drug": "Trastuzumab 440 mg",
                "Generic Name": "Trastuzumab 440 mg"
            }
        },
        {
            "id": 4,
            "name": "Reliance Trastuzumab For Injection",
            "image": "https://5.imimg.com/data5/NJ/EB/KE/SELLER-13363752/h1-500x500.jpeg",
            "price": "₹ 20000 / Vial",
            "info": {
                "description": "Details:r-DNA originFor IV InfusionMulti use vialLyophilized PowderReliance Trastuzumab For Injection + Bacteriostatic water for Injection USP 20 ml-Combokit",
                "Packaging size": "20 ml",
                "Brand": "Hersima",
                "Composition": "Trastuzumab",
                "Manufacturer": "Alkem Laboratories Ltd",
                "Treatment": "Breast Cancer,Stomach Cancer",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Strength": "440 mg",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 5,
            "name": "Paclitaxel for Injectable Suspension 100 mg",
            "image": "https://5.imimg.com/data5/RZ/FU/CG/SELLER-13363752/taxonab-100-mg-500x500.jpeg",
            "price": "₹ 5000 / Vial",
            "info": {
                "description": "Details:Protein Bound ParticlesLyophilized Powder For Suspension For InfusionSterile Single Use VialFor Intravenous Use OnlyFor sale in India only",
                "Packaging Size": "4 x 100 mg/vial",
                "Manufacturer": "Zydus Ingenia",
                "Treatment": "Breast Cancer,Non-small cell Lung Cancer,Pancreatic Cancer",
                "Usage/Application": "Hospital",
                "Brand": "Taxonab",
                "Dose Strength": "100 mg",
                "Composition": "Paclitaxel (Protein-Bound Particles)",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 6,
            "name": "Goserelin Acetate Implant Injection BP",
            "image": "https://5.imimg.com/data5/JW/OD/CO/SELLER-13363752/zoladex-la-10-8-mg-injection-500x500.jpeg",
            "price": "₹ 23000 / Box",
            "info": {
                "description": "Details: \n\nEach prefilled injection contains: Goserelin acetate equivalent to goserelin 10.8 mg peptide base in a long acting sustained release Implant.\nContains one Implant in a prefilled Safesystem syringe with a protective sieeve.\nUse only if pouch is undamaged\nUse immediately after opening pouch\nDo not store above 25 degree C\nKeep all medicines away from children\nTo be sold by retail on the prescription of a Registered Medical Practitioner only.\n",
                "Brand": "Zoladex LA",
                "Packaging Type": "Box",
                "Manufacturer": "AstraZeneca UK Limited",
                "Treatment": "Cancer",
                "Usage/Application": "Hospital, Clinic",
                "Dosage Form": "Injection",
                "Composition": "Goserelin Acetate",
                "Strength": "10.8 mg",
                "Marketed By": "AstraZeneca Pharma India Ltd"
            }
        },
        {
            "id": 7,
            "name": "Gemcitabine Injection IP 1.4 gm",
            "image": "https://5.imimg.com/data5/MG/CR/MO/SELLER-13363752/citafine-1-4-gm-injection-500x500.jpeg",
            "price": "₹ 1800 / Vial",
            "info": {
                "description": "Details:\n\nLyophilized Powder\nTo be diluted for I.V. Infusion\nDosage: As directed by the Physician\nKeep out of reach of children\nStore at 15 - 25 degree C\nDo not refrigerate\nDo not use if vial seal is broken\nWarning: Cytotoxic Agent, To be supplied on demand from Cancer Hospital, Institutions and on prescription of an Oncologist only.\n",
                "Manufacturer": "Emcure Pharmaceuticals",
                "Brand": "Citafine",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital",
                "Composition": "Gemcitabine",
                "Packaging Size": "1 Vial",
                "Dose Strength": "1.4 gm",
                "Treatment": "Cancer"
            }
        },
        {
            "id": 8,
            "name": "Trastuzumab For Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366841515/AC/KA/AD/13363752/trastuzumab-for-injection-500x500.jpg",
            "price": "₹ 19000 / Vial",
            "info": {
                "description": "Details: \n\nr-DNA origin\nFor I.V. Infusion, multiple use vial\nLyophilized Powder\n1 vial of Trastuzumab / 2 vial of BWFI\n",
                "Brand": "Hertraz",
                "Packaging Type": "Box",
                "Manufacturer": "Mylan",
                "Treatment": "Cancer",
                "Usage/Application": "Hospital, Clinic",
                "Composition": "Trastuzumab",
                "Form": "Injectable",
                "Dose/Strength": "440 mg"
            }
        },
        {
            "id": 9,
            "name": "Gemcitabine Injection IP 200 Mg",
            "image": "https://5.imimg.com/data5/FG/HN/AV/SELLER-13363752/citafine-200-mg-injection-500x500.jpeg",
            "price": "₹ 350 / Vial",
            "info": {
                "description": "Details:\n\nSterile Single Dose Vial\nLyophilized\nDosage: As directed by the Physician\nKeep out of reach of children\nStore below 25 degree C\nDo not use if vial seal is broken\nWarning: Cytotoxic Agent, To be supplied on demand from Cancer Hospital, Institutions and on prescription of an Oncologist only.\n",
                "Brand": "Citafine",
                "Manufacturer": "Emcure Pharmceuticals",
                "Packaging Type": "Box",
                "Treatment": "Cancer",
                "Usage/Application": "Hospital",
                "Composition": "Gemcitabine",
                "Packaging Size": "1 Vial",
                "Dose Strength": "200 mg"
            }
        },
        {
            "id": 10,
            "name": "Trastuzumab Lyophilized Powder for Concentrate for Solution for Infusion",
            "image": "https://5.imimg.com/data5/AQ/PL/RL/SELLER-13363752/vivitra-440-mg-injection-500x500.jpeg",
            "price": "₹ 17000 / Box",
            "info": {
                "description": "Details:Each pack contains 1 vial of Lyophilized Powder of Trastuzumab, 1 vial with 20 ml Sterile Bacteriostatic water for injection and package insert.Dosage: As directed by the physicianKeep out of reach of childreNot to be sold by retail without the prescription of an Medical Oncologist.",
                "Brand": "Vivitra",
                "Composition": "Trastuzumab",
                "Manufacturer": "Cadila Healthcare (Zydus)",
                "Treatment": "Breast Cancer,Stomach Cancer",
                "Packaging Size": "1 Vial",
                "Packaging Type": "Box",
                "Form": "Injection",
                "Strength": "440 mg",
                "Marketed By": "Zydus Ingenia",
                "Storage Temperature": "2 to 8 degree C"
            }
        },
        {
            "id": 11,
            "name": "Gemcitabine Injection IP 1 gm",
            "image": "https://5.imimg.com/data5/DM/BY/RE/SELLER-13363752/citafine-1-gm-injection-500x500.jpeg",
            "price": "₹ 1400 / Vial",
            "info": {
                "description": "Details: \n\nSterile Single Dose Vial\nLyophilized \nDosage: As directed by the Physician\nKeep out of reach of children\nStore below 25 degree C\nDo not use if vial seal is broken\nWarning: Cytotoxic Agent, To be supplied on demand from Cancer Hospital, Institutions and on prescription of an Oncologist only.\n",
                "Brand": "Citafine",
                "Manufacturer": "Emcure Pharmaceuticals",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital",
                "Composition": "Gemcitabine",
                "Packaging Size": "1 Vial",
                "Dose Strength": "1 gm",
                "Treatment": "Cancer"
            }
        },
        {
            "id": 12,
            "name": "Leuprolide Acetate For Injectable Suspension",
            "image": "https://5.imimg.com/data5/WH/DT/HZ/SELLER-13363752/e1-500x500.jpeg",
            "price": "",
            "info": {
                "description": "Details:For subcutaneous injectionMust be constituted before useDosage: As directed by the Physiciankeep out of reach of childrenDo not use if solution is not clear or has suspended matterNot to be sold by retail on the prescription of a Registered Medical Practitioner.",
                "Brand": "Eligard",
                "Composition": "Leuprolide Acetate",
                "Manufacturer": "Tolmar Inc.",
                "Treatment": "Cancer",
                "Dose Strength": "22.5 mg every 3 month",
                "Packaging Type": "Box",
                "Form": "Injection",
                "Usage/Application": "Hospital",
                "Marketed By": "Emcure Pharmaceuticals Ltd",
                "Storing Temperature": "2 - 8 degree C or 36 - 46 degree F"
            }
        },
        {
            "id": 13,
            "name": "Enfiera 500 Mg Injection",
            "image": "https://5.imimg.com/data5/GI/IQ/BX/SELLER-13363752/e1-500x500.jpeg",
            "price": "₹ 10000 / Vial",
            "info": {
                "description": "Enfiera 500 mg Injection ( Rituximab 500 mg / 50 ml Injection)Company: Zydus Biochem.",
                "Packaging Size": "Vial",
                "Brand": "Enfiera 500 mg Injection",
                "Composition": "Riruximab 500 mg Injection",
                "Manufacturer": "Zydus Biochem",
                "Packaging": "Vial",
                "Treatment": "Non-Hodgkins Lymphoma,Rheumatoid Arthritis,Blood Cancer",
                "Prescription/Non prescription": "Prescription",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Therapeutic Uses": "Non-Hodgkins Lymphoma,Rheumatoid Arthritis,Blood Cancer"
            }
        },
        {
            "id": 14,
            "name": "Pegaspargase 3750 Iu 5ml Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366837535/LK/IN/VO/13363752/pegaspargase-3750-iu-5ml-injection-500x500.jpg",
            "price": "₹ 40000 / Vial",
            "info": {
                "description": "Details:Store at 2 to 8 degree CAs directed by the PhysicianProtect from lightDo not freeze or shakeTo be sold by retail on the prescription of a Oncologist use only.",
                "Packaging Size": "5 ml",
                "Brand": "Hamsyl",
                "Composition": "Pegaspargase",
                "Manufactured By": "Gennova Biopharmaceuticals Ltd",
                "Treatment": "Lymphoblastic Leukemia",
                "Form": "Injection",
                "Strength": "3750 IU",
                "Marketed By": "Emcure Pharmaceuticals"
            }
        },
        {
            "id": 15,
            "name": "Peg L-Asparaginase Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366838691/GX/JL/EX/13363752/peg-l-asparaginase-injection-500x500.jpg",
            "price": "₹ 25000 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Brand": "Peg L-Aspatero",
                "Packaging Type": "Box",
                "Manufacturer": "Hetero Pharmaceuticals",
                "Treatment": "Blood Cancer (Acute Lymphocytic Leukemia), Hodgkin's Disease",
                "Usage/Application": "Hospital",
                "Composition": "Pegaspargase",
                "Packaging Size": "5 ml single use vial",
                "Form": "Injection",
                "Strength": "750 IU per ml"
            }
        },
        {
            "id": 16,
            "name": "Rituximab Injection 100 mg",
            "image": "https://5.imimg.com/data5/DL/OE/IE/SELLER-13363752/rit1-500x500.jpeg",
            "price": "₹ 3000 / Box",
            "info": {
                "description": "Details:Store at 2-8 degree CDo not freezeDo not shakeKeep out of reach of childrenKeep the vial in outer carton in order to protect from lightNot to be sold by retail without the prescription of a regsitered Medical Practioner.For IV use.",
                "Packaging size": "10 ml",
                "Brand": "RituxiRel",
                "Composition": "Rituximab",
                "Manufactured By": "Reliance Life Sciences Pvt Ltd",
                "Treatment": "Cancer",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Strength": "100 mg",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 17,
            "name": "Rituximab 100 mg/10 mL Injection",
            "image": "https://5.imimg.com/data5/OC/AP/PA/SELLER-13363752/r1001-500x500.jpeg",
            "price": "₹ 4000 / Vial",
            "info": {
                "description": "Details:Keep out of reach of childrenFor intravenous administration after dilutionProtect from light 1 vial of 10 ml concentrate for solution for infusionDo not freeze or shake Before using check for absence of sedimentsTo be sold by retail on the prescription of an Oncologist only.Do not accept if vial seal is broken",
                "Packaging size": "10 ml",
                "Brand": "Rituxem",
                "Composition": "Rituximab",
                "Manufacturer": "Hetero Biopharma Limited",
                "Treatment": "Cancer",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Strength": "100 mg",
                "Packaging Type": "Box",
                "Storing Temperature": "2-8 degree C"
            }
        },
        {
            "id": 18,
            "name": "Rituximab 500 mg/50 ml Injection",
            "image": "https://5.imimg.com/data5/FY/DS/BZ/SELLER-13363752/r1-500x500.jpeg",
            "price": "₹ 9000 / Box",
            "info": {
                "description": "Details:Keep out of reach of childrenFor intravenous administration after dilutionProtect from light 1 vial of 50 ml concentrate for solution for infusionDo not freeze or shakeBefore using check for absence of sedimentsTo be sold by retail on the prescription of an Oncologist only.Do not accept if vial seal is broken",
                "Packaging size": "50 ml",
                "Brand": "Rituxem",
                "Composition": "Rituximab",
                "Manufacturer": "Hetero Biopharma Ltd.",
                "Treatment": "Non-Hodgkin Lymphoma,Rheumatoid Arthritis,Blood Cancer",
                "Form": "Injection",
                "Shelf life": "2 years",
                "Strength": "500 mg",
                "Storing Temperature": "2 to 8 degree C",
                "Marketed By": "Emcure Pharmaceuticals Ltd."
            }
        },
        {
            "id": 19,
            "name": "Reditux Rituximab 500 mg/50 ml Injection",
            "image": "https://5.imimg.com/data5/EH/OS/HU/SELLER-13363752/reditux-500-mg-injection-500x500.jpeg",
            "price": "₹ 19000 / Vial",
            "info": {
                "description": "Reditux 500 mg/50 ml Injection (Rituximab Injection 500 mg/50 ml)Company: Dr Reddy's Laboratories Ltd.",
                "Brand": "Reditux",
                "Packaging Type": "Box",
                "Manufacturer": "Dr. Reddy's",
                "Usage/Application": "Hospital",
                "Treatment": "Cancer",
                "Dosage Form": "Injection",
                "Composition": "Rituximab",
                "Packaging Size": "1 vial,50 ml per vial",
                "Dose/Strength": "500 mg"
            }
        },
        {
            "id": 20,
            "name": "Rituxirel Rituximab Injection 500 mg",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366838305/AB/EQ/FK/13363752/rituxirel-rituximab-injection-500-mg-500x500.jpg",
            "price": "₹ 18000 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Reliance Life Science",
                "Brand": "RituxiRel RN",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital",
                "Composition": "Rituximab",
                "Packaging Size": "50 ml",
                "Dose/Strength": "500 mg",
                "Treatment": "Cancer"
            }
        },
        {
            "id": 21,
            "name": "Oxaliplatin for Injection USP",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366841210/JW/CY/HR/13363752/oxaliplatin-for-injection-usp-500x500.jpg",
            "price": "₹ 800 / Vial",
            "info": {
                "description": "Details:Lyophilized for Intravenous useDosage: As directed by the Oncologist.Storage: Store at a temperature below 25 degree CProtect from light Keep out of reach of childrenTo be sold by retail on the prescription of an Oncologist/Cancer Institution only.",
                "Brand": "Oxoplan",
                "Packaging Type": "Box",
                "Manufacturer": "Samarth Life Sciences Pvt. Ltd.",
                "Treatment": "Colon Cancer,Rectum Cancer",
                "Usage/Application": "Hospital,Clinic",
                "Composition": "Oxaliplatin",
                "Packaging Size": "1 Vial",
                "Dose Strength": "100 mg"
            }
        },
        {
            "id": 22,
            "name": "Rituximab Injection 500 mg",
            "image": "https://5.imimg.com/data5/TA/JI/IA/SELLER-13363752/rit1-500x500.jpeg",
            "price": "₹ 10000 / Vial",
            "info": {
                "description": "Details:Store at 2-8 degree CDo not freezeDo not shakeKeep out of reach of childrenKeep the vial in outer carton in order to protect from lightNot to be sold by retail without the prescription of a regsitered Medical Practioner.For IV use.",
                "Brand": "Rituxirel",
                "Manufactured By": "Reliance Life Sciences Pvt Ltd",
                "Composition": "Rituximab",
                "Treatment": "Cancer",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Strength": "500 mg",
                "Packaging Size": "50 ml",
                "Usage": "Hospital",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 23,
            "name": "Human Growth Hormone Injection",
            "image": "https://tdw.imimg.com/template-tdw/n_image_t.png",
            "price": "",
            "info": {
                "description": "Established as a Partnership firm in the year 2017 at Ahmedabad (Gujarat, India), we “Raj Medico” are a leading Wholesale Trader of a wide range of Anti Cancer Injection, Pharmaceutical Capsules, Pharmaceutical Tablets and many more."
            }
        }
    ]
},
{
    "category": {
        "id": 0,
        "name": "Pharmaceuticals Injection"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Tigez 50 mg Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402579154/UH/LD/OO/13363752/tigez1-500x500.jpeg",
            "price": "₹ 700 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Tigez 50 mg Injection (Tigecycline For Injection USP 50 mg)Company: Lupin Ltd.",
                "Packaging Size": "Vial",
                "Brand": "Tigez 50 mg Injection",
                "Manufacturer": "Lupin Ltd",
                "Composition": "Tigecycline 50 mg Injection",
                "Treatment": "Severe Bacterial Infections",
                "Prescription/Non prescription": "Prescription",
                "Usage/Application": "Commercial",
                "Injectable Form": "Lyophilized Powder",
                "Dose": "50 mg",
                "Medicine Type": "Injection"
            }
        },
        {
            "id": 1,
            "name": "Human Normal Immunoglobulin for Intravenous Administration I.P.",
            "image": "https://5.imimg.com/data5/JW/VB/JS/SELLER-13363752/immunorel-5-100-ml-500x500.jpeg",
            "price": "₹ 10000 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Brand": "ImmunoRel",
                "Packaging Size": "100 ml",
                "Usage/Application": "Hospital",
                "Composition": "Immunoglobulin 5% of 100 ml",
                "Injectable Form": "Liquid",
                "Strength": "5 g",
                "Manufactured By": "Reliance Life Sciences",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 2,
            "name": "Darbepoetin Alfa Injection 40 Mcg",
            "image": "https://5.imimg.com/data5/SI/XA/IE/SELLER-13363752/dargen-40-mcg-0-40-ml-injection-500x500.jpeg",
            "price": "₹ 1300 / Box",
            "info": {
                "description": "Details:For subcutaneous or intravenous use.Single dose pre-filled syringeStore at 2 to 8 degree CDo not freeze or shakeProtect from lightKeep out of reach of childrenFor dosage, indication and administration refer package insert.Warning: To be sold by retail on the prescription of a Registered Medical Practitioner only.",
                "Manufacturer": "Hetero Biopharma Limited",
                "Brand": "Dargen",
                "Treatment": "Anemia",
                "Packaging Type": "Box",
                "Composition": "Darbepoetin Alfa",
                "Packaging Size": "0.40 ml single dose pre-filled syringe",
                "Form": "Injection",
                "Strength": "40 mcg",
                "Marketed By": "Lupin Ltd."
            }
        },
        {
            "id": 3,
            "name": "Darbepoetin Alfa Injection 200 mg",
            "image": "https://5.imimg.com/data5/EP/SY/WQ/SELLER-13363752/cresp-100-mcg-injection-500x500.jpeg",
            "price": "₹ 6000 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Dr. Reddy's",
                "Composition": "Darbepoetin Alfa",
                "Treatment": "Anemia",
                "Brand": "Cresp",
                "Packaging Size": "0.4 ml single use prefilled syringes",
                "Packaging Type": "Box",
                "Dose/Strength": "200 mcg",
                "Form": "Injection",
                "Usage/Application": "Hospital",
                "Number of Syringes": "6 Single Use Prefilled Syringes"
            }
        },
        {
            "id": 4,
            "name": "Cresp Darbepoetin Alfa Injection",
            "image": "https://5.imimg.com/data5/SC/UR/EX/SELLER-13363752/cresp-200-mcg-injection-500x500.jpeg",
            "price": "₹ 3500 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Dr. Reddy's",
                "Dose/Strength": "100 mcg",
                "Composition": "Darbepoetin Alfa",
                "Treatment": "Anemia",
                "Packaging Type": "Box",
                "Brand": "Cresp",
                "Form": "Injection",
                "Usage/Application": "Hospital",
                "Packaging Size": "0.5 ml single use pre filled syringe"
            }
        },
        {
            "id": 5,
            "name": "Darbepoetin Alfa Injection 25 Mcg",
            "image": "https://5.imimg.com/data5/SM/YS/BT/SELLER-13363752/dargen-1-500x500.jpeg",
            "price": "₹ 900 / Box",
            "info": {
                "description": "Details:For subcutaneous or intravenous use.Store at 2 to 8 degree CDo not freeze or shakeProtect from lightKeep out of reach of childrenTo be sold by retail on the prescription of a regsitered Medical Practioner only.",
                "Packaging Size": "0.42 ml single dose pre filled syringe",
                "Brand": "Dargen",
                "Manufacturer": "Hetero Biopharma Limited",
                "Composition": "Darbepoetin Alfa",
                "Treatment": "Anemia",
                "Packaging Type": "Box",
                "Form": "Injection",
                "Dose/Strength": "25 mcg",
                "Usage/Application": "Hospital",
                "Shelf Life": "3 years from the date of manufacturing"
            }
        },
        {
            "id": 6,
            "name": "Human Coagulation Factor IX IP 600 IU",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402578416/PS/GK/DS/13363752/factocel-ix-ip-600-iu-500x500.jpeg",
            "price": "₹ 8000 / Piece",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details:\n\nFreeze Dried Human Coagulation Factor\nVirus Filtered\n",
                "Brand": "Factocel IX",
                "Usage/Application": "Hospital",
                "Dosage Form": "Injection",
                "Packaging Type": "Box",
                "Strength": "600 IU",
                "Manufactured By": "Intas Pharmaceuticals"
            }
        },
        {
            "id": 7,
            "name": "Albumax Human Albumin 20% I.P.",
            "image": "https://5.imimg.com/data5/RL/OU/JM/SELLER-13363752/albumax-20-100-ml-500x500.jpeg",
            "price": "₹ 3800 / Box",
            "info": {
                "description": "Details:For IV useTo be sold by retail on the prescription of a registered Medical Practitioner only.It is dangerous to take this preparation except under Medical supervisionDo not freezeStore in the original package away from the light",
                "Packaging Size": "100 ml",
                "Manufacturer": "Biofarma Plasma Limited",
                "Brand": "Albumax",
                "Usage/Application": "Hospital",
                "Unit": "20%/100 ml",
                "Storage Temperature": "Below 25 degree C",
                "Injectable Form": "Liquid",
                "Shelf Life": "3 years from the date of manufacturing",
                "Packaging Type": "Box",
                "Marketed By": "PlasmaGen Biosciences"
            }
        },
        {
            "id": 8,
            "name": "Snake Venum Antiserum Injection",
            "image": "https://5.imimg.com/data5/TC/OX/HH/SELLER-13363752/asvs-injection-500x500.jpeg",
            "price": "₹ 350 / piece",
            "info": {
                "description": "Details:Combipack of Snake Venom Antiserum with Sterile Water For Injection.For I.V. use Supplied with 10 ml sterile water for injections I.P.",
                "Manufacturer": "Premium Serums And Vaccines Pvt. Ltd.",
                "Composition": "Lyophilized,Polyvalent,Enzyme refined Equine Immunoglobulins",
                "Treatment": "Snake Bite",
                "Packaging Size": "5 x 10 ml",
                "Usage/Application": "Hospital",
                "Form": "Injection",
                "Storage Instruction": "Below 25 degree C",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 9,
            "name": "Hepatitis B Immunoglobulin I.P.",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367100715/RC/OD/QB/13363752/hepatitis-b-immunoglobulin-i-p-500x500.jpg",
            "price": "₹ 1800 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Reliance Life Sciences Pvt Ltd",
                "Usage/Application": "Hospital",
                "Packaging Type": "Box",
                "Dose/Strength": "100 IU",
                "Form": "Injection",
                "Brand": "HepaRel",
                "Packaging Size": "1 ml",
                "Composition": "Hepatitis B Immunoglobulin"
            }
        },
        {
            "id": 10,
            "name": "Alburel Os Solution For Infusion",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367099565/ZJ/DN/MC/13363752/alburel-os-solution-for-infusion-500x500.jpg",
            "price": "₹ 4000 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "100 ML",
                "Composition": "Human albumin 20% solution",
                "Manufacturer": "Bio Products Laboratory Ltd.",
                "Unit": "20%/100 ml",
                "Brand": "Alburel (Reliance)",
                "Usage/Application": "Hospital",
                "Strength": "20g",
                "Company": "Reliance Life Sciences",
                "Manufactured By": "Bio Products Laboratory Ltd.",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 11,
            "name": "Lonopin 40 mg/0.4 ml Enoxaparin Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367088658/ZW/NR/VS/13363752/lonopin-40-mg-0-4-ml-enoxaparin-injection-500x500.png",
            "price": "₹ 200 / Piece",
            "info": {
                "description": "LONOPIN 40mg PFS injection stops the already formed clots from growing larger in size and restricts the formation of any new clots. Blood clots may be formed in veins, a condition is known as (deep vein thrombosis or DVT), in the arteries of the lungs (Pulmonary embolism). If you are being treated with this LONOPIN 40mg PFS injection, avoid doing things that increase the risk of bleeding or injury. Bleeding can be dangerous, so look out for the symptoms actively and speak to your doctor.\nThe most common side effects of this LONOPIN 40mg PFS injection include prolonged bleeding, pain, or discomfort at the injection site, dark urine, confusion, changes in vision. A severe headache or stomach ache could be a sign of bleeding. Report to your doctor immediately in this case. \n \nBefore using this LONOPIN 40mg PFS injection tell your doctor, if you have any pre-existing medical conditions like diabetes, high blood pressure, or recent onset of stroke. This is to ensure the safety of the LONOPIN 40mg PFS injection. Do not take this if you have any current bleeding. Pregnant women and breastfeeding mothers should consult a doctor before using this LONOPIN 40mg PFS injection. Drinking alcoholic beverages while taking this LONOPIN 40mg PFS injection can increase the risk of bleeding. So, avoid alcoholic consumption.  ",
                "Number of Syringe": "1 Pre-Filled Syringe",
                "Dosage/Strength": "40 mg/0.4 ml",
                "Brand": "Lonopin",
                "Drug Type": "Anticoagulant Drug",
                "Composition(Salt)": "Enoxaparin Sodium",
                "Manufacturer Name": "Bharat Serums & Vaccines Ltd",
                "Prescription/ Non Prescription": "Prescription",
                "Usage": "Treatment and prevention of blood clots"
            }
        },
        {
            "id": 12,
            "name": "Terlipressin Acetate Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/2/391530554/OQ/YX/LB/13363752/terlipressin-acetate-injection-500x500.jpg",
            "price": "₹ 400 / PIECE",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "10 ml",
                "Composition": "Terlipressin",
                "Packaging Type": "Box",
                "Strength": "1 mg",
                "Brand": "Erliso",
                "Manufactured By": "Wockhardt",
                "Form": "Injection",
                "Treatment": "Low Blood Pressure"
            }
        },
        {
            "id": 13,
            "name": "Alburel Human Normal Albumin",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367101141/KT/IN/QS/13363752/alburel-human-normal-albumin-500x500.jpg",
            "price": "₹ 4200 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Composition": "Albumin",
                "Manufacturer": "Reliance Life Science",
                "Brand": "AlbuRel",
                "Usage/Application": "Hospital",
                "Unit": "20%/100 ml",
                "Strength": "20 g",
                "Packaging Size": "100 ml",
                "Packaging Type": "Box",
                "Protein": "20%"
            }
        },
        {
            "id": 14,
            "name": "Human Hepatitis B Immunoglobulin Injection I.P.",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 1700 / Vial",
            "info": {
                "description": "PlasmaHep 100 IU/0.5 ml Injection (Human Hepatitis B Immunoglobulin I.P. 0.5 ml)Company: PlasmaGen BioSciences Pvt Ltd.",
                "Brand": "PlasmaHep",
                "Usage/Application": "Hospital",
                "Composition": "Human Hepatitis B Immunoglobulin",
                "Injectable Form": "Liquid",
                "Packaging Size": "0.5 ml",
                "Form Of Medicine": "Injection",
                "Strength": "100 I.U."
            }
        },
        {
            "id": 15,
            "name": "Fosfomycin Sodium For Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402579697/PD/YO/ZP/13363752/f1-500x500.jpeg",
            "price": "₹ 1000 / Vial",
            "info": {
                "description": "Details:Powder for solution for InfusionFor IV use onlyFor single use onlyProtect from lightKeep all medicines out of the reach of childrenNot to be sold by retail without the prescription of a regsitered Medical Practioner.",
                "Packaging Size": "1 Vial",
                "Brand": "Fonyl",
                "Manufacturer": "Glenmark Pharmaceuticals Ltd",
                "Composition": "Fosfomycin Sodium",
                "Treatment": "Kidney Infections",
                "Shelf Life": "3 years from the date of manufacturing",
                "Form": "Injection",
                "Dosage": "As directed by the Physician",
                "Storing Temperature": "Below 25 degree C",
                "Strength": "4 g"
            }
        },
        {
            "id": 16,
            "name": "Rosinox-40 Enoxaparin Injection 40 mg/0.4 ml",
            "image": "https://5.imimg.com/data5/SELLER/Default/2020/12/ZL/DH/PE/13363752/1-500x500.jpeg",
            "price": "₹ 185 / Piece",
            "info": {
                "description": "Rosinox 40mg/0.4ml PFS injection is an anticoagulant which is used to prevent and treat blood clots. It prevents the existing clots from becoming larger and inhibits the formation of new clots. This injection is prescribed for prophylaxis for deep vein thrombosis, prophylaxis for angina and myocardial infarction, deep vein thrombosis prophylaxis after surgery, pulmonary embolism. However, the uses of the medicine mentioned are not exhaustive, there may be other reasons or situations in which the medicine might be used.\nRosinox 40mg/0.4ml PFS injection contains enoxaparin which is a low molecular weight heparin with anticoagulant properties. It works by inactivating blood clotting proteins such as thrombin, thereby preventing the formation of blood clots and prevents blockages in the blood vessels of the body. The active ingredient of Rosinox 40mg/0.4ml PFS injection is Enoxaparin Sodium 40mg",
                "Number of Syringe": "1 Pre-Filled Syringe",
                "Dosage/Strength": "40 mg/0.4 ml",
                "Brand": "Rosinox-40",
                "Drug Type": "Anticoagulant Drug",
                "Composition(Salt)": "Enoxaparin Sodium",
                "Manufacturer Name": "Roselabs Bioscience Ltd",
                "Prescription/ Non Prescription": "Prescription",
                "Usage": "Treatment and prevention of blood clots"
            }
        },
        {
            "id": 17,
            "name": "Erythropoietin Injection I.P.",
            "image": "https://5.imimg.com/data5/BY/LZ/NO/SELLER-13363752/repoitin-4000-iu-injection-500x500.jpeg",
            "price": "₹ 250 / Box",
            "info": {
                "description": "Details:To be sold by retail on the prescription of a registered medical practitioner only.For S.C./I.V. useKeep out of reach of childrenProtect from light",
                "Packaging Size": "0.4 ml pre filled syringe",
                "Brand": "Repoitin",
                "Manufacturer": "Serum Institute Of India Pvt. Ltd",
                "Composition": "Erythropoietin",
                "Treatment": "Anemia due to chronic kidney disease",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Dosage": "As directed by the physician",
                "Storage Temperature": "2 - 8 degree C",
                "Strength": "4000 IU"
            }
        },
        {
            "id": 18,
            "name": "Rosinox-60 Enoxaparin Injection 60 mg/0.6 ml",
            "image": "https://5.imimg.com/data5/SELLER/Default/2021/1/JX/PJ/SY/13363752/rosi-1-500x500.jpg",
            "price": "₹ 180 / Piece",
            "info": {
                "description": "Rosinox 60mg/0.6ml PFS injection is an anticoagulant which is used to prevent and treat blood clots. It prevents the existing clots from becoming larger and inhibits the formation of new clots. This injection is prescribed for prophylaxis for deep vein thrombosis, prophylaxis for angina and myocardial infarction, deep vein thrombosis prophylaxis after surgery, pulmonary embolism. However, the uses of the medicine mentioned are not exhaustive, there may be other reasons or situations in which the medicine might be used.\nRosinox 60mg/0.6ml PFS injection contains enoxaparin which is a low molecular weight heparin with anticoagulant properties. It works by inactivating blood clotting proteins such as thrombin, thereby preventing the formation of blood clots and prevents blockages in the blood vessels of the body. The active ingredient of Rosinox 60mg/0.6ml PFS injection is Enoxaparin Sodium 60mg\n ",
                "Number of Syringe": "1 Pre-Filled Syringe",
                "Dosage/Strength": "60 mg/0.6 ml",
                "Brand": "Rosinox-60",
                "Drug Type": "Anticoagulant Drug",
                "Composition(Salt)": "Enoxaparin Sodium",
                "Manufacturer Name": "Roselabs Bioscience Ltd",
                "Prescription/ Non Prescription": "Prescription",
                "Usage": "Treatment and prevention of blood clots"
            }
        },
        {
            "id": 19,
            "name": "Tirofiban Hydrochloride Injection",
            "image": "https://5.imimg.com/data5/YI/SB/YE/SELLER-13363752/aggribloc-5-mg-infusion-500x500.jpeg",
            "price": "₹ 1200 / Vial",
            "info": {
                "description": "Details:For Intravenous Infusion OnlyDosage: As directed by the PhysicianKeep out of reach of childrenTo be sold by retail on the prescription of a Specialist only.Do not use the infusion if the contents are not clear or show particulate matter.Store at a temperature not exceeding 30 degree C.Protect from lightDo not freeze",
                "Manufacturer": "Gland Pharma Limited",
                "Brand": "Aggribloc",
                "Treatment": "Heart Attack",
                "Composition": "Tirofiban",
                "Usage/Application": "Hospital",
                "Packaging Size": "100 ml",
                "Form": "Injection",
                "Strength": "5 mg",
                "Marketed By": "Abbott Healthcare Pvt. Ltd."
            }
        },
        {
            "id": 20,
            "name": "Paracetamol Injection 1000 mg/100 ml",
            "image": "https://5.imimg.com/data5/NZ/NZ/QV/SELLER-13363752/febimol-injection-500x500.jpeg",
            "price": "₹ 100 / Bottle",
            "info": {
                "description": "Details:For Intravenous AdministrationSingle dose containerIndications: For symptomatic treatment of pain and fever.Keep in a cool placeProtect from light Do not freezeWarning: To be sold by retail on the prescription of a Registered Medical Practioner only.",
                "Strength": "1000mg",
                "Pack Size": "100 ml",
                "Pack Type": "Box",
                "Drug Composition": "Paracetamol 1000mg",
                "Brand": "Febimol",
                "Manufacturer": "Shree Krishna Keshav Laboratories ltd.",
                "Usage/Application": "Treat Pain and Reduce Fever",
                "Prescription/Non-Prescription": "Prescription",
                "Marketed By": "Medimark Biotech"
            }
        },
        {
            "id": 21,
            "name": "Exemptia 40 Mg Injection",
            "image": "https://5.imimg.com/data5/KD/AV/UJ/SELLER-13363752/e1-500x500.jpeg",
            "price": "₹ 7500 / vial",
            "info": {
                "description": "Details:Single dose pre filled syringe of 40 mg /0.8 mlFor subcutaneous use onlyThe pack contains pre filled syringe, package insert and medication guide.Protect from light. Do not freeze.As directed by the PhysicianStore between 2 to 8 degree CKeep out of reach of childrenTo be sold by retail on the prescription of a Rheumatologist or an Orthopaedician or a Gastroenterologist or a Dermatologist only.",
                "Brand": "Exemptia",
                "Strength / Dose": "40 mg / 0.8 ml",
                "Manufacturer": "Zydus",
                "Composition": "Adalimumab 40mg/0.8ml",
                "Packaging Type": "Pre Filled Syringe",
                "Treatment": "Ankylosing Spondylitis,Rheumatoid Arthritis,Psoriasis,Ulcerative Colitis & Crohn's Disease",
                "Shelf life": "3 years from the date of manufacturing"
            }
        },
        {
            "id": 22,
            "name": "Recombinant Streptokinase For Injection IP",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367101909/MT/JJ/TW/13363752/recombinant-streptokinase-for-injection-ip-500x500.jpg",
            "price": "₹ 600 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details:\n\nLyophilized\nFor IV use\nAlbumin free preparation\n\n",
                "Packaging Size": "5 ml single use vial",
                "Manufacturer": "Abbott",
                "Composition": "Streptokinase",
                "Dose/Strength": "1500000 IU",
                "Packaging Type": "Box",
                "Form": "Injection",
                "Brand": "Icikinase",
                "Usage": "Hospital"
            }
        },
        {
            "id": 23,
            "name": "Anidulafungin For Injection 100 mg",
            "image": "https://5.imimg.com/data5/YC/KY/VU/SELLER-13363752/b-dula-100-mg-injection-500x500.jpeg",
            "price": "₹ 6000 / Vial",
            "info": {
                "description": "Details:Store at 2-8 degree C.Do not freezekeep medicine out of reach of childrenLyophilizedPowder for Concentrate for solutionFor I.V. infusion onlyFor single use only",
                "Packaging Size": "1 Combipack or 1 vial",
                "Manufacturer": "BDR Pharmaceuticals Int'l Pvt. Ltd.",
                "Treatment": "Aspergillus Infection",
                "Brand": "B-Dula",
                "Usage/Application": "Hospital",
                "Composition": "Anidulafungin",
                "Dosage": "As directed by the Physician",
                "Packaging Type": "Box",
                "Strength": "100 mg"
            }
        },
        {
            "id": 24,
            "name": "I-nem 500 mg Injection",
            "image": "https://5.imimg.com/data5/WF/ET/XU/SELLER-13363752/i-nem-1-500x500.jpeg",
            "price": "₹ 350 / Vial",
            "info": {
                "description": "i-nem 500 mg injection (Imipenem 500 mg + Cilastatin 500 mg)Company: Glenmark Pharmaceuticals Ltd.",
                "Manufacturer": "Glenmark Pharmaceuticals Ltd",
                "Treatment": "Severe Bacterial Infections",
                "Prescription/Non prescription": "Prescription",
                "Brand": "Glenmark Pharmaceuticals Ltd",
                "Usage/Application": "Hospital",
                "Composition": "Imipenem 500 mg + Cilastatin 500 mg",
                "Injectable Form": "Lyophilized Powder",
                "Dose": "1 gm",
                "Packaging Size": "Vial",
                "Medicine Type": "Injection"
            }
        },
        {
            "id": 25,
            "name": "Sodium Bicarbonate Injection IP",
            "image": "https://5.imimg.com/data5/LF/BV/GR/SELLER-13363752/bibonate-iv-500x500.jpeg",
            "price": "₹ 100 / Vial",
            "info": {
                "description": "Details:For IV InfusionDosage: As directed by the PhysicianStore at a temperature below 25 degree CProtect from lightTo be sold by retail on the prescription of a Registered Medical PractitionerSterile, Non-Pyrogenic Single dose containerCaution: Even invisible damage to bottle caused during storage or transit may result in contamination. Do not use if leak/Fungus found or contents not clear but return for replacementShake well before use",
                "Brand": "Bibonate",
                "Usage/Application": "Hospital",
                "Composition": "Sodium Bicarbonate",
                "Injectable Form": "Liquid",
                "Packaging Size": "100 ml",
                "Concentration": "8.4% w/v",
                "Manufactured By": "Shree Krishna Keshav Laboratories Ltd.",
                "Marketed By": "Medimark Biotech",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 26,
            "name": "Stpase 1500000 IU Injection",
            "image": "https://5.imimg.com/data5/OR/RW/XK/SELLER-13363752/s1-500x500.jpeg",
            "price": "₹ 700 / Vial",
            "info": {
                "description": "STPase 1500000 IU Injections (Streptokinase 1500000 IU Injecetion IP)Company: Cadila Pharmaceuticals Limited.",
                "Packaging Size": "6 vials in a box",
                "Brand": "STPase 1500000 IU",
                "Manufacturer": "Cadila Pharmaceuticals  Limited",
                "Composition": "Streptokinase 1500000 IU IP",
                "Treatment": "Heart Attack & Pulmonary Embolism",
                "Prescription/Non prescription": "Prescription",
                "Shelf Life": "2 years from the date of manufacturing",
                "Form": "Injection",
                "Country of Origin": "Made in India"
            }
        },
        {
            "id": 27,
            "name": "Clariwok IV 500 mg Injection",
            "image": "https://5.imimg.com/data5/GI/HV/SC/SELLER-13363752/clariwok-iv-500-mg-injection-500x500.jpeg",
            "price": "₹ 880 / Piece",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details: \n\nLyophilized Injection\nSingle dose vial\nPowder for solution for IV infusion only\n",
                "Packaging Size": "1 vial",
                "Brand": "Clariwok",
                "Manufacturer": "Wockhardt",
                "Usage/Application": "Hospital",
                "Injectable Form": "Liquid",
                "Medicine Type": "Injection",
                "Strength": "500 mg"
            }
        },
        {
            "id": 28,
            "name": "Neukine Filgrastim Injection IP PFS 300 mcg",
            "image": "https://5.imimg.com/data5/AX/QT/FC/SELLER-13363752/flagrastim-injection-500x500.jpg",
            "price": "₹ 180 / Piece",
            "info": {
                "description": "Details:Recombinant Human Granulocyte Colony Stimulating Factor (rHu G-CSF) InjectionFor subcutaneous (s.c.) or intravenous (I.V.) infusion only1 x 1.0 ml single dose prefilled syringe",
                "Manufacturer": "Intas Pharmaceuticals",
                "Treatment": "HIV/AIDS",
                "Usage/Application": "Hospital",
                "Composition": "Filgrastim",
                "Brand": "Neukine",
                "Dose/Strength": "300 mcg",
                "Packaging Type": "Box",
                "Packaging Size": "1.0 ml",
                "Form": "Injection"
            }
        }
    ]
},
{
    "category": {
        "id": 3,
        "name": "Anti Bacterial Injections"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Tigecycline for Injection USP 50 mg",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367081836/GA/XJ/XK/13363752/tigecycline-for-injection-usp-50-mg-1000x1000.jpg",
            "price": "₹ 460 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details: \n\nFor IV use only\nFor Single use\n",
                "Manufacturer": "Alkem HospiCare",
                "Treatment": "Bacterial Infections",
                "Brand": "Tgkem",
                "Dosage Form": "Injection",
                "Composition": "Tigecycline",
                "Usage/Application": "Hospital",
                "Packaging Size": "1 Vial",
                "Dose/Strength": "50 mg",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 1,
            "name": "Polymyxin B for Injection",
            "image": "https://5.imimg.com/data5/VX/PO/QN/SELLER-13363752/poly-mxb-5-00-000-units-injection-500x500.jpeg",
            "price": "₹ 500 / Vial",
            "info": {
                "description": "Details:LyophilizedFor Intrathecal/IM/IV InfusionDiscard unused portionUse as directed by the physicianStore in a cool, dry place.Protect from lightNot to be sold by retail without th prescription of a Registered Medical PractitionerCaution: This injection should not be usedif it contains visible particulate matter after reconstitution ",
                "Packaging Size": "1 vial",
                "Manufacturer": "Gufic Biosciences Limited",
                "Composition": "Polymyxin B",
                "Brand": "Poly-MxB",
                "Treatment": "Bacterial Infections",
                "Usage/Application": "Hospital",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Marketed By": "Bharat Serums & Vaccines Limited"
            }
        },
        {
            "id": 2,
            "name": "Meropenem Injection IP 1000 mg",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 250 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "1 vial",
                "Brand": "Innomer",
                "Manufacturer": "BD Pharmaceuticals",
                "Composition": "Meropenem",
                "Treatment": "Bacterial Infections",
                "Usage/Application": "Hospital",
                "Drug Strength": "1000 mg",
                "Form": "Injection",
                "Packaging Type": "Vial"
            }
        },
        {
            "id": 3,
            "name": "Meropenem Injection IP 500 mg",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 350 / Vial",
            "info": {
                "description": "Details:Powder for Intravenous Injection or infusion.Reconstitute before use.This injection should not be used if it contains visible solid particles after reconstitution.Dosage: As directed by the PhysicianKeep out of reach of childrenStore below 30 degree CNot to be sold by retail without th prescription of a Registered Medical Practitioner",
                "Manufacturer": "Prosperity 6 Pharmaceuticals",
                "Injection Site": "IV Only",
                "Treatment": "Bacterial Infections",
                "Drug Strength": "500 mg",
                "Brand": "Merotrol",
                "Usage/Application": "Hospital",
                "Composition": "Meropenem",
                "Packaging Size": "1 Vial",
                "Prescription Required": "Yes",
                "Prescription/Non Prescription": "Prescription"
            }
        },
        {
            "id": 4,
            "name": "Meropenem Injection IP 1000 mg",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 550 / Vial",
            "info": {
                "description": "Details:Powder for Intravenous Injection or infusion.Reconstitute before use.This injection should not be used if it contains visible solid particles after reconstitution.",
                "Manufacturer": "Prosperity 6 Pharmaceuticals",
                "Treatment": "Bacterial Infection",
                "Brand": "Merotrol",
                "Usage/Application": "Hospital",
                "Composition": "Meropenem",
                "Drug Strength": "1 g",
                "Packaging Size": "Vial",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Marketed By": "Lupin Ltd."
            }
        },
        {
            "id": 5,
            "name": "Fosfomycin Sodium For Injection 4g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 1250 / Vial",
            "info": {
                "description": "Details:\n\nPowder for solution for Infusion\nFor IV use only\nFor single use only\n100 ml sterile water for injections inside\n",
                "Manufacturer": "Intas Pharmaceuticals",
                "Dosage Form": "Injection",
                "Composition": "Fosfomycin Sodium",
                "Brand": "Fosfotas",
                "Packaging Size": "1 Vial",
                "Usage/Application": "Hospital",
                "Dose/Strength": "4 gm",
                "Treatment": "Bacterial Infection",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 6,
            "name": "Meronem Meropenem Injection IP 1g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 1600 / Vial",
            "info": {
                "description": "Details: \n\nSterile powder for intravenous injection or infusion\nReconstitute before use.\nDo not freeze.\n\n",
                "Brand": "Meronem",
                "Manufacturer": "AstraZeneca UK Limited",
                "Strength": "1g",
                "Injection Site": "IV Only",
                "Treatment": "Bacterial Infections",
                "Prescription Required": "Yes",
                "Injectable Form": "Solution",
                "Prescription/Non Prescription": "Prescription",
                "Usage/Application": "Hospital",
                "Drug Name": "Meropenem Injection"
            }
        },
        {
            "id": 7,
            "name": "Polymyxin B Sulphate Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 350 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Samarth Life Sciences",
                "Composition": "Polymyxin B Sulphate",
                "Treatment": "Bacterial Infections",
                "Brand": "Poly-B",
                "Dose/Strength": "5,00,000 IU",
                "Usage/Application": "Hospital",
                "Packaging Size": "1 Vial",
                "Packaging Type": "Box",
                "Dosage Form": "Injection"
            }
        },
        {
            "id": 8,
            "name": "Mero Meropenem Injection with Strength:1g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 350 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.\n\n",
                "Brand": "Mero",
                "Manufacturer": "Aristo",
                "Strength": "1g",
                "Injection Site": "IV Only",
                "Treatment": "Bacterial Infections",
                "Composition": "Meropenem",
                "Prescription Required": "Yes",
                "Injectable Form": "Solution",
                "Form": "Injection",
                "Prescription/Non Prescription": "Prescription"
            }
        },
        {
            "id": 9,
            "name": "Cefepime And Tazobactam for Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 200 / Vial",
            "info": {
                "description": "Details:Dosage: As directed by the PhysicianFor IV and IM use onlyKeep out of reach of childrenStore at a temperature not exceeding 30 degree CProtect from lightCaution: If any foreign particle is visible in the vial after dissolving the contents, please do not use the solutionNot to be sold by retail without th prescription of a Registered Medical PractitionerMfd. under the guidance of Biocon Limited.",
                "Packaging Size": "Single dose Vial",
                "Brand": "Celrim TZ",
                "Manufacturer": "Aqua Vitoe Laboratories",
                "Composition": "Cefepime & Tazobactam",
                "Treatment": "Bacterial Infections",
                "Form": "Injection",
                "Strength": "1.125 g",
                "Marketed By": "Biocon Limited",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 10,
            "name": "Cefuroxime Sodium Injection IP",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 280 / Vial",
            "info": {
                "description": "Details:\n\nPowder for Injection\nIntravenous Injection\nNot to be sold by retail without th prescription of a Registered Medical Practitioner\n",
                "Brand": "Supacef",
                "Manufacturer": "GlaxoSmithKline Pharmaceuticals Limited",
                "Composition": "Cefuroxime Sodium",
                "Treatment": "Bacterial infections",
                "Shelf life": "2 years",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Strength": "1.5 gm"
            }
        },
        {
            "id": 11,
            "name": "Sulbactam And Cefoperazone for Injection 1 gm",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 450 / Vial",
            "info": {
                "description": "Details:For IV or IM use onlyIt is dangerous to take this preparation except in accordance with the medical advice.Not to be sold by retail without the prescription of a Registered Medical Practitioner. ",
                "Manufacturer": "Astral SteriTech Pvt. Ltd.",
                "Treatment": "Bacterial Infections",
                "Brand": "Magnex",
                "Usage/Application": "Hospital",
                "Composition": "Cefoperazone,Sulbactam",
                "Packaging Size": "1 Vial",
                "Form": "Injection",
                "Strength": "1 g",
                "Packaging Type": "Box",
                "Marketed By": "Pfizer Limited"
            }
        },
        {
            "id": 12,
            "name": "Sulbactam And Cefoperazone for Injection 1.5 gm",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 600 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details:\n\nFor IV or IM use only\nStore below 25 degree C\nProtect from light\n",
                "Packaging Size": "1 vial",
                "Brand": "Magnex Forte",
                "Manufacturer": "Pfizer Limited",
                "Composition": "Cefoperazone,Sulbactam",
                "Treatment": "Bacterial Infections",
                "Usage/Application": "Hospital",
                "Medicine Type": "Injection",
                "Packaging Type": "Box",
                "Strength": "1.5 g"
            }
        },
        {
            "id": 13,
            "name": "Sulbactam And Cefoperazone for Injection 2 gm",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 600 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details:\n\nFor IV or IM use only\nStore below 25 degree C\nProtect from light\n",
                "Manufacturer": "Pfizer Limited",
                "Treatment": "Bacterial Infections",
                "Brand": "Magnex",
                "Usage/Application": "Hospital",
                "Composition": "Cefoperazone,Sulbactam",
                "Packaging Size": "1 Vial",
                "Form": "Injection",
                "Strength": "2 g",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 14,
            "name": "Cefoperazone Sulbactam for Injection 3g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 168 / Vial",
            "info": {
                "description": "Details:For IV/IM use onlyCombipack with Sterile Water for Injections IPDosage: As directed by the PhysicianStore below 30 degree CProtect from light and moisture.Do not freezeThe constituted solution should be used immediately after preparation.It is dangerous to take this preparation except in accordnace with the medical advice.Not to be sold by retail without the prescription of a Registered Medical Practioner only.",
                "Packaging Size": "1 vial",
                "Manufacturer": "Malik Lifesciences Pvt. Ltd.",
                "Composition": "Cefoperazone & Sulbactam",
                "Brand": "Lypex SB",
                "Treatment": "Bacterial Infection",
                "Packaging Type": "Box",
                "Dosage Form": "Injection",
                "Dose/Strength": "3 gm",
                "Marketed By": "Lyka Healthcare Ltd."
            }
        },
        {
            "id": 15,
            "name": "Cefuroxime Injection IP 1.5 g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 100 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "1 vial",
                "Brand": "Cefahead",
                "Manufacturer": "Lyka Healthcare",
                "Composition": "Cefuroxime",
                "Treatment": "Bacterial Infections",
                "Usage/Application": "Hospital",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Strength": "1.5 g"
            }
        },
        {
            "id": 16,
            "name": "Lypex Cefoperazone And Sulbactam for Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 90 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Details: \n\nFor IM/IV use\nCombipack with Sterile Water for Injections IP\n",
                "Manufacturer": "Lyka Healthcare",
                "Composition": "Cefoperazone and Sulbactam",
                "Brand": "Lypex-SB",
                "Treatment": "Bacterial Infections",
                "Packaging Size": "1 Vial",
                "Dosage Form": "Injection",
                "Dose/Strength": "1.5g",
                "Usage/Application": "Hospital",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 17,
            "name": "Piperacillin and Tazobactam Injection 4.5 g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 120 / Vial",
            "info": {
                "description": "Details:\n\nFor IV use only\nDosage: As directed by the Physician\nStore below 30 degree C\nKeep out of reach of children\nNot to be sold by retail without th prescription of a Registered Medical Practitioner\nCaution: Do not use the injection if the contents are not clear or contains visible particulate matter after reconstitution. \n",
                "Brand": "Tazar",
                "Manufacturer": "Prosperity 6 Pharmaceuticals",
                "Strength": "4.5 gm",
                "Injection Site": "IV",
                "Packaging Size": "Single dose vial",
                "Prescription Required": "Yes",
                "Composition": "Piperacillin,Tazobactam",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Prescription": "Prescription"
            }
        },
        {
            "id": 18,
            "name": "Piperacillin And Tazobactam for Injection USP",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 175 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Brand": "Tazact",
                "Manufacturer": "Cipla",
                "Strength": "4.5 gm",
                "Injection Site": "IV",
                "Composition": "4 g piperacillin  and 0.5g tazobactam",
                "Packaging Size": "1 vial",
                "Prescription Required": "Yes",
                "Form": "Injection",
                "Packaging Type": "Box",
                "Prescription": "Prescription"
            }
        },
        {
            "id": 19,
            "name": "Zostum Sulbactam And Cefoperazone for Injection 1.5g",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 85 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "1 vial",
                "Manufacturer": "Zuventus",
                "Composition": "Sulbactam and Cefoperazone",
                "Brand": "Zostum",
                "Treatment": "Bacterial Infections",
                "Packaging Type": "Box",
                "Form": "Injection",
                "Usage/Application": "Hospital",
                "Strength": "1.5 g"
            }
        },
        {
            "id": 20,
            "name": "Teicoplanin Injection 400 mg",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 1200 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Brand": "Ticocin",
                "Usage/Application": "Hospital",
                "Composition": "Teicoplanin",
                "Form Of Medicine": "Injection",
                "Packaging Type": "Box",
                "Manufactured By": "Cipla",
                "Treatment": "Bacterial Infections",
                "Strength": "400 mg"
            }
        }
    ]
},
{
    "category": {
        "id": 4,
        "name": "Pharmaceutical Tablets"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Entecavir Tablets IP 0.5 mg",
            "image": "https://5.imimg.com/data5/ZN/VL/PM/SELLER-13363752/e1-500x500.jpeg",
            "price": "₹ 1000 / Bottle",
            "info": {
                "description": "Details:As directed by the PhysicianColours: Titanium DioxideStore below 30 degree C in dry placeProtect from lightKeep out of reach of children To be sold by retail on the prescription of a regsitered Medical Practioner.",
                "Packaging Size": "30 tablets",
                "Strength": "0.5 mg",
                "Composition": "Entecavir",
                "Treatment": "HIV/AIDS",
                "Brand": "EnteHep",
                "Manufacturer": "Cadila Healthcare Ltd (Zydus)",
                "Form": "Tablet",
                "Shelf life": "2 years from the date of manufacturing",
                "Marketed by": "Zydus Heptiza",
                "Packaging Type": "Bottle"
            }
        },
        {
            "id": 1,
            "name": "Omalirel 150mg Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/1/375725915/MV/NJ/RD/13363752/omalirel-1-500x500.jpeg",
            "price": "₹ 8500 / Pack",
            "info": {
                "description": "Omalirel Injection is a monoclonal antibody. It is used in the treatment of moderate to severe asthma in both adults and children. It eases the symptoms of asthma such as wheezing, breathlessness, tightness in your chest, and coughing.",
                "Strength": "150 mg",
                "Packaging Size": "1 PFS",
                "Brand": "Omalirel 150 mg Injection",
                "Also gives": "PCD Pharma",
                "Shelf life": "2 Years from the date of manufacturing.",
                "Country of Origin": "Made in India"
            }
        },
        {
            "id": 2,
            "name": "Mycophenolate Mofetil Tablets IP",
            "image": "https://5.imimg.com/data5/WB/MV/LZ/SELLER-13363752/m1-500x500.jpeg",
            "price": "₹ 200 / Strip",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Strength": "500 mg",
                "Packaging size": "3 x 10 Tablets",
                "Brand": "Mofetyl",
                "Composition": "Mycophenolate",
                "Manufacturer": "RPG Life Sciences",
                "Treatment": "Kidney, Heart, and Liver Transplantation",
                "Form": "Tablet",
                "Usage": "Hospital, Clinic",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 3,
            "name": "Imatinib Tablets IP 400 Mg",
            "image": "https://5.imimg.com/data5/AU/YH/XJ/SELLER-13363752/imat-400-mg-tablets-500x500.jpeg",
            "price": "₹ 400 / Strip",
            "info": {
                "description": "Details:Store below 30 degree CProtect from light and moistureColours: Iron Oxide Red and Titanium Dioxide IPkeep out of reach of children",
                "Packaging size": "10 Tablets",
                "Brand": "Imat",
                "Composition": "Imatinib",
                "Manufacturer": "Cadila Healthcare (Zydus)",
                "Treatment": "Cancer",
                "Packaging Type": "Box",
                "Form": "Tablet",
                "Strength": "400 mg",
                "Dosage": "As directed by the Physician"
            }
        },
        {
            "id": 4,
            "name": "Bdron Abiraterone Acetate Tablets IP",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367098577/NL/HZ/JN/13363752/bdron-abiraterone-acetate-tablets-ip-500x500.jpg",
            "price": "₹ 9000 / Bottle",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers. For Oral Use",
                "Brand": "Bdron",
                "Composition": "Abiraterone Acetate",
                "Manufacturer": "BDR Pharmaceuticals Int'l Pvt. Ltd.",
                "Treatment": "Cancer",
                "Packaging Size": "120 Tablets per bottle",
                "Form": "Tablets",
                "Strength": "250 mg",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 5,
            "name": "Sofosbuvir And Velpatasvir Tablets",
            "image": "https://5.imimg.com/data5/TE/KA/SV/SELLER-13363752/mh1-500x500.jpeg",
            "price": "₹ 9000 / Bottle",
            "info": {
                "description": "Details: \n\nColors: Lake of Indigo carmine, Yellow Oxide of Iron, Titanium Dioxide\nAs directed by the Hepatologist.\nDo not store above 30 degree C\nStore in the original container.\nProtect from moisture\nKeep out of the reach and sight of children\nMyHep All is manufactured under license from Gilead Sciences Ireland UC\nTo be sold by retail on the prescription of Hepatologist only.\n",
                "Packaging Size": "28 tablets",
                "Strength": "400 mg / 100 mg",
                "Composition": "Sofosbuvir, Velpatasvir",
                "Treatment": "Hepatitis C",
                "Brand": "MyHep All",
                "Manufacturer": "Mylan Laboratories Ltd",
                "Form": "Tablet",
                "Shelf life": "15 months from the date of manufacturing",
                "Marketed By": "Mylan Pharmaceuticals Pvt. Ltd.",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 6,
            "name": "Megestrol Acetate Tablets IP",
            "image": "https://5.imimg.com/data5/IF/OI/KS/SELLER-13363752/megasty-160-mg-tablet-500x500.jpeg",
            "price": "₹ 700 / Strip",
            "info": {
                "description": "Details:Store protected from light and moistureKeep out of reach of children.",
                "Packaging Size": "3 x 1 x 10 tablets",
                "Brand": "Megasty",
                "Composition": "Megestrol Acetate",
                "Manufacturer": "Aureate Healthcare Pvt Ltd",
                "Treatment": "Cancer",
                "Dose Strength": "160 mg",
                "Form": "Tablet",
                "Packaging Type": "Box",
                "Dosage": "As directed by the physician"
            }
        },
        {
            "id": 7,
            "name": "Xidroin Midodrine Hydrochloride Tablet",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367096527/IJ/CV/FH/13363752/xidroin-500x500.jpg",
            "price": "₹ 845 / Strip",
            "info": {
                "description": "Composition- Midodrine Hydrochloride USP 2.5Brand name - XidroinManufactured by- BDR Pharmaceuticals Pvt Ltd",
                "Strength": "2.5 mg",
                "Brand Name": "Xidorin Tab",
                "Manufacturer": "Cipla",
                "Packaging Type": "Strips",
                "Form": "Tablet",
                "Country of Origin": "Made in India"
            }
        },
        {
            "id": 8,
            "name": "Capecitabine Tablets I.P. 500 mg",
            "image": "https://5.imimg.com/data5/BF/YL/SD/SELLER-13363752/c1-500x500.jpeg",
            "price": "₹ 250 / Stripe",
            "info": {
                "description": "Details:Colours: Iron Oxide red and Titanium Dioxide I.P.Not to be sold by retail without the prescription of a registered medical practitioner.Store below 30 degree C and protected from moisture.",
                "Brand": "Cacit",
                "Composition": "Capecitabine",
                "Manufacturer": "Admac Lifesciences",
                "Treatment": "Cancer",
                "Dose Strength": "500 mg",
                "Packaging Type": "Box",
                "Packaging Size": "10 x 10 tablets",
                "Form": "Tablet",
                "Usage/Application": "Hospital",
                "Marketed By": "Zydus Oncoscienses"
            }
        },
        {
            "id": 9,
            "name": "Midodrine Hydrochloride Tablets",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367098078/DO/RP/OD/13363752/midodrine-hydrochloride-tablets-500x500.jpg",
            "price": "₹ 1850 / Strip",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Gutron 2.5 mg Tablet (Midodrine Hydrochloride)Company: Bluemed.",
                "Composition": "Midodrine Hydrochloride",
                "Form": "Tablets",
                "Packaging Size": "3 x 20 tablets",
                "Usage/Application": "Hospital, Clinic",
                "Brand": "Gutron",
                "Packaging Type": "Box",
                "Treatment": "Low Blood Pressure",
                "Strength": "2.5 mg"
            }
        },
        {
            "id": 10,
            "name": "Bdron Abiraterone Acetate Tablets IP 500 mg",
            "image": "https://5.imimg.com/data5/GU/RS/NX/SELLER-13363752/bdron-500-mg-tablets-500x500.jpeg",
            "price": "₹ 10000 / Bottle",
            "info": {
                "description": "Details:Protected from light and moistureKeep all medicines out of the reach and sight of childrenSwallow whole tabletDo not crush or chewTo be sold by retail on the prescription of an Oncologist only.",
                "Brand": "Bdron",
                "Composition": "Abiraterone Acetate",
                "Manufacturer": "BDR Pharmaceuticals Int'l Pvt Ltd",
                "Treatment": "Cancer",
                "Packaging Size": "60 Tablets",
                "Packaging Type": "Box",
                "Dose/Strength": "500 mg",
                "Form": "Tablet",
                "Dosage": "As directed by the Physician",
                "Storage Temperature": "below 30 degree C"
            }
        },
        {
            "id": 11,
            "name": "Capecitabine Tablets IP 500 mg",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367091084/BE/AL/RL/13363752/capecitabine-tablets-ip-500-mg-500x500.jpg",
            "price": "₹ 1300 / STRIPE",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "30 tablets",
                "Manufacturer": "Dr Reddy's Laboratories",
                "Treatment": "Cancer",
                "Usage/Application": "Hospital",
                "Brand": "Capiibine",
                "Dose Strength": "500 mg",
                "Composition": "Capecitabine",
                "Form": "Tablet",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 12,
            "name": "Melphalan Tablets IP 2 Mg",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367091656/TU/JK/FX/13363752/melphalan-tablets-ip-2-mg-500x500.jpg",
            "price": "₹ 1600 / Bottle",
            "info": {
                "description": "Details: \n\nColours: Iron Oxide Red and Titanium Dioxide IP\nKeep medicine out of reach of children\nTo be sold by retail on the prescription of an Oncologist only.\n",
                "Packaging size": "25 Tablets",
                "Brand": "Alkacel",
                "Composition": "Melphalan",
                "Manufacturer": "Celon Labs",
                "Treatment": "Cancer",
                "Form": "Tablet",
                "Dose Strength": "2 mg",
                "Usage/Application": "Hospital",
                "Packaging Type": "Box",
                "Dosage": "As directed by the Oncologist"
            }
        },
        {
            "id": 13,
            "name": "Voritek 200mg Tablet",
            "image": "https://5.imimg.com/data5/SELLER/Default/2021/1/LO/HG/HM/13363752/vori-1-500x500.jpeg",
            "price": "₹ 1100 / Strip",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Uses- Treatment of fungal infectionComposition- Voriconazole ",
                "Packaging Size": "4 tablets",
                "Brand": "Cipla",
                "Manufacturer": "Cipla Ltd",
                "Composition": "Voriconazole 200 mg",
                "Treatment": "Fungal Infection",
                "Prescription/Non prescription": "Prescription",
                "Form": "Tablet",
                "Country of Origin": "Made in India"
            }
        },
        {
            "id": 14,
            "name": "Azathioprine Tablet I.P.",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367095934/KK/QO/FW/13363752/azathioprine-tablet-i-p-500x500.jpg",
            "price": "₹ 65 / Strip",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Composition": "Azathioprine",
                "Brand": "Azoran",
                "Manufacturer": "RPG Life Sciences",
                "Dosage Form": "Tablet",
                "Packaging Size": "10 x 10 tablets",
                "Packaging Type": "Box",
                "Dose/Strength": "50 mg",
                "Usage/Application": "Hospital,Clinic",
                "Treatment": "Prevention of Organ Rejection in transplant & Rheumatoid Arthritis"
            }
        },
        {
            "id": 15,
            "name": "Difidox Doxycycline For Injection USP 100mg",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367092873/VH/EQ/JA/13363752/difidox-doxycycline-for-injection-usp-100mg-500x500.jpg",
            "price": "₹ 200 / Vial",
            "info": {
                "description": "Details:Sterile water for injection IP 10mlFor IV Infusion onlyLyophilisedMust dilute reconstituted solution as per details given in pack insert.Not to be sold by retail without the prescription of a regsitered Medical Practioner.Discard the solution if found hazy.Protect from light ",
                "Brand": "Difidox",
                "Dosage": "100mg",
                "Packaging Size": "1 vial",
                "Form": "Injection",
                "Composition": "Doxycycline",
                "Manufacturer": "Fusion Healthcare Pvt Ltd",
                "Treatment": "Bacterial Infections",
                "Shelf life": "2 years from the date of manufacturing",
                "Storage Temperature": "Below 25 degree C",
                "Strength": "100 mg"
            }
        },
        {
            "id": 16,
            "name": "Mycophenolic Acid Delayed Release Tablets USP",
            "image": "https://5.imimg.com/data5/AD/UD/CN/SELLER-13363752/mofetyl-s-360-mg-tablets-500x500.jpeg",
            "price": "₹ 200 / Box",
            "info": {
                "description": "Details:\n\nAs prescribed by the Physician.\nStore at controlled room temperature.\nProtect from moisture\nkeep out of reach of children\nDo not crush the tablets\nSwallow the whole tablets\nNot to be sold by retail without the prescription of a regsitered Medical Practioner.\n",
                "Usage/Application": "Hospital",
                "Packaging Size": "10 x 10 Tablets",
                "Packaging Type": "Box",
                "Brand": "Mofetyl-S",
                "Form": "Tablets",
                "Composition": "Mycophenolic",
                "Dose/Strength": "360 mg",
                "Manufactured By": "RPG Life Sciences Ltd",
                "Treatment": "Kidney, Heart, and Liver Transplantation"
            }
        }
    ]
},
{
    "category": {
        "id": 5,
        "name": "Pharmaceutical Medicines"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Dried Factor VIII Fraction I.P. 500 IU",
            "image": "https://5.imimg.com/data5/XV/SQ/MV/SELLER-13363752/hemorel-a-500-iu-500x500.jpeg",
            "price": "₹ 5500 / BOX",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Strength": "500 IU",
                "Manufacturer": "Reliance Life Sciences Pvt Ltd",
                "Form": "Injection",
                "Brand": "HemoRel-A",
                "Usage/Application": "Hospital",
                "Storage Temperature": "2 - 8 degree C"
            }
        },
        {
            "id": 1,
            "name": "Fibrin Sealant Kit I.P 1 ml",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 6500 / Piece",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Reliance Life Sciences Pvt. Ltd.",
                "Brand": "ReliSeal",
                "Usage": "Hospital",
                "Composition": "Fibrinogen, Thrombin, Aprotinin",
                "Packaging Size": "1 ml",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 2,
            "name": "Fibrin Sealant Kit I.P 0.5 ml",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Reliance Life Sciences Pvt. Ltd.",
                "Brand": "ReliSeal",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital",
                "Composition": "Fibrinogen,Thrombin,Aprotinin",
                "Packaging Size": "0.5 ml"
            }
        },
        {
            "id": 3,
            "name": "Dried Factor VIII Fraction I.P.",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Reliance Life Sciences Pvt Ltd",
                "Brand": "HemoRel A",
                "Treatment": "Hemophilia A",
                "Shelf life": "2 years from the date of manufacturing",
                "Form": "Injection",
                "Storage Temperature": "2 - 8 degree C",
                "Strength": "250 IU"
            }
        },
        {
            "id": 4,
            "name": "Tacrolomus 1mg Capsule",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 398 / Stripe",
            "info": {
                "description": "Established as a Partnership firm in the year 2017 at Ahmedabad (Gujarat, India), we “Raj Medico” are a leading Wholesale Trader of a wide range of Anti Cancer Injection, Pharmaceutical Capsules, Pharmaceutical Tablets and many more.",
                "Strength": "1 mg",
                "Packaging Size": "1*10 Capsules",
                "Packaging Type": "Box",
                "Side Effect": "As per prescription",
                "Country of Origin": "Made in India"
            }
        }
    ]
},
{
    "category": {
        "id": 6,
        "name": "Pharmaceutical Capsules"
    },
    "medicines": [
        {
            "id": 0,
            "name": "25mg Lenalidomide Capsule",
            "image": "https://5.imimg.com/data5/RY/QK/SB/SELLER-13363752/lenangio-25-mg-capsules-500x500.jpeg",
            "price": "₹ 2200 / Bottle",
            "info": {
                "description": "Details:Protected from light and moistureKeep out of reach of childrenWarning: To be sold by retail on the prescription of a Registered medical Practitioner only.It should never be taken by pregnant women",
                "Manufacturer": "Naprod Life Sciences Pvt. Ltd",
                "Treatment": "Cancer",
                "Brand": "Lenangio",
                "Packaging Type": "Bottle",
                "Usage/Application": "Hospital",
                "Composition": "Lenalidomide",
                "Packaging Size": "10 Capsules/Bottle",
                "Dose Strength": "25 mg",
                "Generic Name": "Lenalidomide25 mg",
                "Form": "Capsules"
            }
        },
        {
            "id": 1,
            "name": "Lenalidomide 10 mg Capsules",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 800 / Bottle",
            "info": {
                "description": "Lenangio 10 mg Capsules (Lenalidomide Capsules 10 mg)Company: Dr. Reddy's Laboratories Ltd.",
                "Packaging Size": "10 capsules per bottle",
                "Brand": "Lenangio",
                "Manufacturer": "Dr. Reddy's",
                "Composition": "Lenalidomide",
                "Treatment": "Multiple myeloma and lepra reaction",
                "Shelf Life": "3 years",
                "Form": "Capsules",
                "Strength": "10 mg"
            }
        },
        {
            "id": 2,
            "name": "Tenofovir Disoproxil Fumarate 300mg Tablets",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 794 / Bottle",
            "info": {
                "description": "Established as a Partnership firm in the year 2017 at Ahmedabad (Gujarat, India), we “Raj Medico” are a leading Wholesale Trader of a wide range of Anti Cancer Injection, Pharmaceutical Capsules, Pharmaceutical Tablets and many more.",
                "Dose/Strength": "300 mg",
                "Packaging Size": "1x10Tablets",
                "Packaging Type": "Box",
                "Brand": "Cipla",
                "Usage / Application": "Hospital"
            }
        },
        {
            "id": 3,
            "name": "Lycopene with Multivitamin And Multimineral Soft Gelatin Capsules",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 125 / Strip",
            "info": {
                "description": "Details:Usage: 1 or 2 capsules a day or as directed by health professionalDietary SupplementNot for medicinal purposeStore in a cool and dry place below 20 degree CProtect from direct light",
                "Manufacturer": "Aureate Healthcare Pvt Ltd",
                "Brand": "Lycogem Forte",
                "Packaging Type": "Box",
                "Packaging Size": "10 x 1 x 10 Softgel Capsules",
                "Usage/Application": "Hospital,Clinic",
                "Composition": "Lycopine 6%,Vitamin C,Green Tea Extract,Curcumin 95%,L-Arginine,Soya Lecithin,Folic Acid etc.",
                "Form": "Capsules"
            }
        }
    ]
},
{
    "category": {
        "id": 7,
        "name": "Bevacizumab"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Cizumab Bevacizumab 400mg Injection",
            "image": "https://5.imimg.com/data5/PN/MF/RS/SELLER-13363752/c1-500x500.jpeg",
            "price": "₹ 21000 / Vial",
            "info": {
                "description": "Details:1 vial of 16 ml concentrate for solution for intravenous infusionFor intravenous administration after dilutionDo not freeze or shakeProtect from lightKeep out of reach of childrenTo be sold by retail on the prescription of a Oncologist only",
                "Packaging size": "16 ml",
                "Brand": "Cizumab",
                "Composition": "Bevacizumab",
                "Manufacturer": "Hetero Biopharma Ltd.",
                "Treatment": "Cancer",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing",
                "Strength": "400 mg",
                "Marketed By": "Hetero Healthcare Ltd.",
                "Packaging Type": "Box"
            }
        },
        {
            "id": 1,
            "name": "Bevacirel 400 Mg Bevacizumab Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 16000 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.BevaciRel 400 mg/ 16 ml (Bevacizumab 400 mg/ 16 ml)Company: Reliance Life Sciences Pvt Ltd.",
                "Packaging Size": "400 mg",
                "Brand": "BevaciRel",
                "Composition": "Bevacizumab",
                "Packaging": "Vial",
                "Manufacturer": "Reliance Life Sciences Pvt Ltd",
                "Dosage Form": "Salt",
                "Treatment": "Colon & Rectum Cancer,Non-small cell lung cancer,Kidney Cancer,Brain Tumor,Cervical Cancer.",
                "Prescription/Non prescription": "Prescription",
                "Form": "Injection",
                "Shelf life": "2 years from the date of manufacturing"
            }
        },
        {
            "id": 2,
            "name": "Bevatas 400mg /16mL Bevacizumab Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 22000 / Vial",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Brand": "Bevatas",
                "Manufacturer": "Intas Pharmaceuticals",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital",
                "Composition": "Bevacizumab",
                "Packaging Size": "16 ml",
                "Dose Strength": "400 mg",
                "Treatment": "Cancer"
            }
        }
    ]
},
{
    "category": {
        "id": 8,
        "name": "Human Erythropoietin Injection"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Wepox 10000 IU Injection",
            "image": "https://5.imimg.com/data5/IG/ZB/BG/SELLER-13363752/wep1-500x500.jpeg",
            "price": "₹ 700 / Piece",
            "info": {
                "description": "Wepox 10000 IU Pre-filled Syringe (Erythropoietin Injection IP 10000 IU {r-DNA origin})Company: Wockhardt Ltd.",
                "Packaging Size": "PFS",
                "Manufacturer": "Wockhardt Ltd",
                "Prescription/Non prescription": "Prescription",
                "Brand": "Wepox 10000 IU",
                "Composition": "Erythropoietin Injection IP 10000 IU (r-DNA origin)",
                "Treatment": "Anemia caused by Kidney Disease / Anemia caused by Cancer Chemotherapy / Anemia caused by HIV",
                "Shelf life": "2 years from the date of manufacturing",
                "Form": "Injection"
            }
        },
        {
            "id": 1,
            "name": "Cresp 60 mcg Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 2700 / Box",
            "info": {
                "description": "Cresp 60 mcg Injection (Darbepoetin Alfa 60 mcg Injection)Company: Dr Reddy's Laboratories Limited.",
                "Packaging Size": "PFS",
                "Brand": "Cresp 60 mcg Injection",
                "Manufacturer": "Dr Reddy's Laboratories Limited",
                "Composition": "Darbepoetin Alfa 60 mcg Injection",
                "Treatment": "Anemia due to chronic kidney disease & anemia due to chemotherapy",
                "Prescription/Non prescription": "Prescription",
                "Drug": "Darbepoetin Alfa 60 mcg Injection",
                "Packaging Type": "PFS",
                "Dose/Strength": "60 mcg",
                "Form": "Injection"
            }
        }
    ]
},
{
    "category": {
        "id": 9,
        "name": "Anticoagulant Drugs"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Xarelto 15 mg Tablets",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402578010/NA/MP/DC/13363752/x1-500x500.jpeg",
            "price": "₹ 3500 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Xarelto 15 mg Tablets (Rivaroxaban 15 mg Tablets)Company: Bayer Zydus Pvt Ltd.",
                "Packaging Size": "2 strips in a box",
                "Brand": "Xarelto 15 mg Tablets",
                "Manufacturer": "Bayer Zydus Pvt Ltd",
                "Composition": "Rivaroxaban 15 mg Tablets",
                "Treatment": "Deep Vein Thrombosis,Pulmonary Embolism,Stroke Prevention",
                "Prescription/Non prescription": "Prescription",
                "Form": "Tablet",
                "Shelf life": "2 years from the date of manufacturing"
            }
        },
        {
            "id": 1,
            "name": "Xarelto 20 mg Tablets",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 3500 / Box",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Xarelto 20 mg Tablets (Rivaroxaban 20 mg Tablets)Company: Bayer Zydus Pharma Pvt Ltd.",
                "Packaging Size": "2 strips of 14 Tablets each",
                "Brand": "Xarelto 20 mg Tablets",
                "Manufacturer": "Bayer Zydus Pvt Ltd",
                "Composition": "Rivaroxaban 20 mg Tablets",
                "Treatment": "Deep Vain Thrombosis,Pulmonary embolism,Stroke Prevention",
                "Prescription/Non prescription": "Prescription",
                "Form": "Tablet",
                "Shelf life": "2 years from the date of manufacturing"
            }
        }
    ]
},
{
    "category": {
        "id": 10,
        "name": "Teriparatide Injection"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Terifrac Teriparatide Injection",
            "image": "https://5.imimg.com/data5/UB/EP/PR/SELLER-13363752/terifrac-injection-500x500.jpeg",
            "price": "₹ 4200 / Box",
            "info": {
                "description": "Details:Teriparatide [rhu PTH (1-34)] InjectionTerifrac ( r-DNA origin ) 750 mcg/3 mlFor Subcutaneous use onlyDosage: As directed by the PhysicianStore between 2-8 degree CProtect from light Do not freezekeep out of reach of childrenNot to be sold by retail without the prescription of a Registered medical practitioner.",
                "Strength": "750 mcg",
                "Pack Size": "3ml",
                "Pack Type": "Cartridge",
                "Composition": "Teriparatide 750mcg",
                "Brand": "Terifrac",
                "Manufacturer": "Intas Pharmaceuticals Ltd",
                "Usage/Application": "To Treat Osteoporosis",
                "Prescription/Non-Prescription": "Prescription"
            }
        },
        {
            "id": 1,
            "name": "Osteri Teriparatide Injection I.P.",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "₹ 5000 / Box",
            "info": {
                "description": "Details: \n\nRecombinant Human Parathyroid Hormone (rhPTH1-34 Injection I.P.)\n\n\nPre filled pen device\nFor subcutaneous use only \n30 Needles pack free along with this pen\n\n\nNot to be sold separately\n\n ",
                "Strength": "750 mcg",
                "Packaging Size": "3ml",
                "Packaging Type": "Box",
                "Composition": "Teriparatide 750mcg",
                "Brand": "Osteri",
                "Manufacturer": "Virchow Biotech Private Limited",
                "Usage/Application": "To Treat Osteoporosis",
                "Marketed By": "Emcure Pharmaceuticals Ltd."
            }
        }
    ]
},
{
    "category": {
        "id": 11,
        "name": "Anti Cancer Medicines"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Tenofovir Alafenamide Tablets",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402587898/AU/HF/FF/13363752/tenofovir-alafenamide-tablets-500x500.jpg",
            "price": "",
            "info": {
                "description": "Naproplat 450 mg/45 ml (Carboplatin Injection IP 450mg/45 ml)Company: Miracalus Pharma Pvt Ltd.We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Dose Strength": "50 mg",
                "Manufacture By": "Zydus",
                "Brand": "Zydus",
                "Packaging Size": "Customized",
                "Packaging Type": "Stripe"
            }
        },
        {
            "id": 1,
            "name": "Posaconazole Noxafil Tablet",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "",
            "info": {
                "description": "Naproplat 450 mg/45 ml (Carboplatin Injection IP 450mg/45 ml)Company: Miracalus Pharma Pvt Ltd.We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Strength": "100 mg",
                "Packaging Size": "Customized",
                "Brand": "Posatral",
                "Prescription/Non prescription": "Prescription",
                "Also Gives": "Third Party Manufacturing, PCD Pharma Franchise",
                "Prescription Required": "Yes"
            }
        }
    ]
},

{
    "category": {
        "id": 12,
        "name": "Pharmaceutical Injectables"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Vivem Plus 1 gm Injection",
            "image": "https://5.imimg.com/data5/SELLER/Default/2024/3/402587484/NW/XR/UK/13363752/v1-500x500.jpeg",
            "price": "₹ 400 / Vial",
            "info": {
                "description": "Vivem Plus 1 gm Injection (Meropenem 1 gm Injection)Company: Intas Pharmaceuticals Ltd.",
                "Packaging Size": "Vial",
                "Brand": "Vivem Plus 1 gm Injection",
                "Manufacturer": "Intas Pharmaceuticals Ltd",
                "Composition": "Meropenem 1 gm Injection",
                "Treatment": "Severe Bacterial Infections",
                "Prescription/Non prescription": "Prescription",
                "Usage/Application": "Hospital",
                "Injectable Form": "Lyophilized Powder",
                "Drug Name": "Meropenem 1 gm",
                "Drug Strength": "1 gm"
            }
        },
        {
            "id": 1,
            "name": "Ferric Carboxymaltose Injection",
            "image": "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=",
            "price": "",
            "info": {
                "description": "Ferric Carboxymaltose injection"
            }
        }
    ]
},
{
    "category": {
        "id": 13,
        "name": "Antiviral Drugs"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Abbott Velpaclear Tablets",
            "image": "https://5.imimg.com/data5/SELLER/Default/2020/11/HG/ME/BC/13363752/vel1-500x500.jpeg",
            "price": "₹ 7000 / Bottle",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Packaging Size": "28 Tablets in a bottle",
                "Strength": "Sofosbuvir 400 mg & Veltapasvir 100 mg Tablets",
                "Composition": "Sofosbuvir 400 mg & Veltapasvir 100 mg Tablets",
                "Treatment": "Chronic hepatitis C virus (HCV) infection",
                "Prescription/Non prescription": "Prescription",
                "Brand": "Velpaclear",
                "Manufacturer": "Abbott",
                "Form": "Tablet",
                "Shelf life": "2 years from the date of manufacturing",
                "Packaging Type": "Bottles"
            }
        }
    ]
},
{
    "category": {
        "id": 14,
        "name": "Anti Cancer Capsules"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Lenangio 5 mg Capsules",
            "image": "https://5.imimg.com/data5/OX/PV/VX/SELLER-13363752/l1-500x500.jpeg",
            "price": "₹ 500 / Bottle",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.Lenangio 5 mg Capsules(Lenalidomide 5 mg Capsules)Company: Dr Reddy's Laboratories Ltd.",
                "Packaging Size": "10 capsules in a bottle",
                "Brand": "Lenangio 5 mg",
                "Composition": "Lenalidomide 5 mg capsules",
                "Manufacturer": "Dr Reddy's Laboratories Ltd",
                "Treatment": "Multiple Myeloma & Lepra Reaction",
                "Prescription/Non prescription": "Prescription",
                "Dose Strength": "5 mg",
                "Category": "Multiple Myeloma & Lepra Reaction",
                "Drug": "Lenalidomide 5 mg",
                "Generic Name": "Lenalidomide 5 mg"
            }
        }
    ]
},
{
    "category": {
        "id": 15,
        "name": "Anti Cancer Drugs"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Azel Enzalutamide 40 mg Capsules",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/367095131/SM/CO/CY/13363752/azel-enzalutamide-40-mg-capsules-500x500.jpg",
            "price": "₹ 17000 / Box",
            "info": {
                "description": "Azel 40 mg Capsules (Enzalutamide Capsules 40mg)Company: Dr Reddy's Laboratories Ltd.",
                "Manufacturer": "Dr. Reddy's",
                "Brand": "Azel",
                "Composition": "Enzalutamide",
                "Packaging Size": "4 x 28 capsules",
                "Treatment": "Cancer",
                "Prescription/Non prescription": "Prescription",
                "Form": "Capsules",
                "Deals in": "cancer",
                "Packaging Type": "Box",
                "Usage/Application": "Hospital"
            }
        }
    ]
},
{
    "category": {
        "id": 16,
        "name": "Posaconazole Oral Suspension"
    },
    "medicines": [
        {
            "id": 0,
            "name": "Posaconazole Oral Suspension 40 mg/ml",
            "image": "https://5.imimg.com/data5/SELLER/Default/2023/12/366841921/YQ/ZD/JC/13363752/posaconazole-oral-suspension-40-mg-ml-500x500.jpg",
            "price": "₹ 12000 / Bottle",
            "info": {
                "description": "We are engaged in offering this product to our clients. All our products have been widely appreciated by our customers.",
                "Manufacturer": "Intas Pharmaceuticals Ltd",
                "Composition": "Posaconazole",
                "Dosage Form": "Syrup (Suspension)",
                "Brand": "Picasa",
                "Usage/Application": "Hospital",
                "Packaging Size": "105 ml",
                "Packaging Type": "Box",
                "Strength": "40 mg/ml",
                "Manufactured By": "Intas",
                "Treatment": "Fungal Infections"
            }
        }
    ]
}
];
export const userMedicinesDataLoader = () => {

    const medicinesData = data;

    return medicinesData;
};

